// Explication au clic sur « Charge rapide » ou « Batterie longue durée » (écran « Batterie vide ») quand ce n'est pas encore disponible : une fenêtre dit
// quoi partager pour y avoir droit (« … ou installe l'appli pour jouer sans limite »), avec un bouton pour le faire (« Recharger en partageant » /
// « Obtenir en partageant ») et, dessous, un lien « Installer l'appli » : un vrai lien vers la page web du jeu (GAME_URL, config/gameUrl.js), ouverte dans un
// nouvel onglet, pas le geste d'installation du navigateur. open() se résout avec 'share' (le bouton) ou null (fenêtre fermée, lien suivi compris).
import { $ } from './dom.js';
import { createDialog } from './dialog.js';
import { GAME_URL } from '../config/gameUrl.js';

/**
 * @param {object} deps
 * @param {(key: string, params?: object) => string} deps.t
 * @param {string} [deps.gameUrl]  la page web du jeu, vers laquelle mène « Installer l'appli » (la configuration par défaut)
 * @param {boolean} [deps.installPromo]  proposer d'installer l'appli (« …, ou installe l'appli pour jouer sans limite » et le lien) ; faux dans l'appli native, déjà installée
 */
export function createChargeInfoDialog({ t, gameUrl = GAME_URL, installPromo = true }) {
  const title = $('chargeInfoTitle');
  const text = $('chargeInfoText');
  const share = $('btnChargeInfoShare');
  const install = $('btnChargeInfoInstall');
  install.href = gameUrl;
  install.target = '_blank';
  install.rel = 'noopener noreferrer';
  const dialog = createDialog($('chargeInfoOverlay'), {
    focus: '#btnChargeInfoShare',
    /** @param {{ kind?: 'fast'|'longLife', shared?: number, total?: number }} options */
    onOpen({ kind = 'fast', shared = 0, total = 0 } = {}) {
      const long = kind === 'longLife';
      title.textContent = t(long ? 'overlay.longLife' : 'overlay.fastCharge');
      text.textContent = (long ? t('chargeInfo.longLife', { shared, total }) : t('chargeInfo.fast')) + t(installPromo ? 'chargeInfo.orInstall' : 'chargeInfo.stop'); // « … ou installe l'appli pour jouer sans limite. »
      share.textContent = t(long ? 'chargeInfo.shareLongLife' : 'chargeInfo.shareFast');
      install.textContent = t('chargeInfo.install');
      install.hidden = !installPromo;
    },
  });
  share.addEventListener('click', () => dialog.close('share'));
  return { open: (options) => dialog.open(options), close: dialog.close, isOpen: dialog.isOpen };
}
